import { useLoginStore } from '@/login/stores/useLoginStore';
import { ResErr, ResgateManager } from '@/newApi/services/ResgateManager';
import type { LegalEntity } from '@sysarb/sysarb-types/general/types';
import type { QueryOptions} from '@tanstack/vue-query';
import { queryOptions } from '@tanstack/vue-query';

type LegalEntitiesOptions = {
    queries: {
        getLegalEntities: (enabled?: boolean) => QueryOptions<LegalEntity[], Error>;
        getLegalEntity: (legalEntityId: string | null) => QueryOptions<LegalEntity, Error>;
    };
};

export const legalEntities: LegalEntitiesOptions = {
    queries: {
        getLegalEntities: (enabled: boolean = true): QueryOptions<LegalEntity[], Error> => {
            const { instanceTopic } = useLoginStore();
            const resourceId = `v1.${instanceTopic}.legalentities`;
            return queryOptions<LegalEntity[], Error>({
                meta: {
                    subscribe: false,
                    type: 'resgate',
                    resourceId,
                },
                queryKey: ['legalEntities', resourceId, instanceTopic],
                queryFn: async (): Promise<LegalEntity[]> => {
                    if (instanceTopic == null) throw new Error('Invalid subdomain');
                    const res = await ResgateManager.getInstance().collection<LegalEntity>(resourceId);
                    if (res instanceof ResErr) throw new Error(res.message);
                    return res.list;
                },
                enabled: () => enabled,
            });
        },
        getLegalEntity: (legalEntityId: string | null): QueryOptions<LegalEntity, Error> => {
            const { instanceTopic } = useLoginStore();
            const hasId = legalEntityId != null && legalEntityId !== '';
            const resourceId = `v1.${instanceTopic}.legalentity.${legalEntityId}`;
            return queryOptions<LegalEntity, Error>({
                meta: {
                    subscribe: false,
                    type: 'resgate',
                    resourceId,
                },
                queryKey: ['legalEntity', resourceId, instanceTopic],
                queryFn: async (): Promise<LegalEntity> => {
                    if (instanceTopic == null) throw new Error('Invalid subdomain');
                    const res = await ResgateManager.model<LegalEntity>(resourceId);
                    if (res instanceof ResErr) throw new Error(res.message);
                    return res;
                },
                retry: false,
                enabled: () => hasId,
            });
        },
    },
};
